import { ReactNode } from 'react';
import { SupportAccessPrompt } from './support-access-prompt';
import { SupportSessionBanner } from './support-session-banner';

/**
 * Wraps the signed-in parts of the app: users see and answer support access
 * requests, and a super admin acting as a user sees who they're acting as.
 */
export const SupportAccessLayer = ({ children }: { children: ReactNode }) => (
  <>
    {children}
    <SupportAccessPrompt />
    <SupportSessionBanner />
  </>
);

export default SupportAccessLayer;
